<div class="banner-wrapper">
  <div class="banner">
    <div class="left-panel">
      <div class="logo">
        <app-logo [width]="242" />
      </div>
      <div class="info-container">
        <div class="hint">
          <mat-icon class="hint-icon">schedule</mat-icon>
          <span>20+ accounts connected today</span>
        </div>
        <div class="title">{{ bannerContent.title }}</div>
        <div class="text">
          {{ bannerContent.subtitle }}
        </div>
        <div class="button-container">
          <button
            mat-stroked-button
            appTrackActionSeen
            data-test="i-ll-do-it-later-button"
            data-analytics="nylas-promo-do-it-later-button"
            color="primary"
            (click)="navigateToPreviousPage()"
          >
            I'll do it later
          </button>
          <button
            mat-flat-button
            appTrackActionSeen
            data-analytics="nylas-promo-connect-button"
            color="primary"
            (click)="connectNylas()"
          >
            {{ bannerContent.buttonText }}
          </button>
        </div>
      </div>
    </div>
    <div class="right-panel">
      @if (isVideoBanner(bannerContent)) {
        <app-vimeo-player
          class="vimeo-player-container"
          [id]="bannerContent.vimeoVideoId"
          [responsive]="true"
          [loop]="true"
          [mute]="false"
        />
      } @else {
        <img
          class="nylas-image"
          alt="nylas banner"
          [src]="bannerContent.image"
        />
      }
    </div>
  </div>
</div>
